import { useOrganization } from '@clerk/clerk-react'

import { CAREFORCE_ORG_SLUG } from '@/config/constants'
import { useIsGlobalAdmin } from './useIsGlobalAdmin'

/**
 * True when the user is a global admin AND their ACTIVE organization is Careforce.
 *
 * Narrower than `useIsSuperUser()`, which is membership-based and stays true while
 * a Careforce admin browses a customer org. This mirrors hoku's `is_super_user`
 * (auth.py: `org_slug === 'careforce'` and `org_role === 'org:global_admin'`) —
 * the claim `to_supabase_jwt()` puts on the wire, and the one helpcare's
 * allocation-board gate reads.
 *
 * Use it for surfaces that go through that gate, so the client and the server
 * agree on who can see them. For "is this person a Careforce admin at all",
 * regardless of which org they're currently in, use `useIsSuperUser()`.
 */
export function useIsCareforceOrgAdmin(): boolean {
  const isGlobalAdmin = useIsGlobalAdmin()
  const { organization } = useOrganization()

  return isGlobalAdmin && organization?.slug === CAREFORCE_ORG_SLUG
}
